import { SHOPPING_LIST_LIST_UPDATE_MEMBER, FETCH_SLL_SUCCESS, FETCH_SLL_BEGIN, FETCH_SLL_FAILURE} from '../actions/shopping_list_list_actions';

export default function (state = {}, action) {
  switch (action.type) {
    case FETCH_SLL_SUCCESS: {
      var res = [];
      action.payload.data.Data.forEach(function (list) {
          list["Key"] = list.Shopping_List_Id;
          res.push(list);
        });
      return {
        shop_list_list: res,
        shop_lists_loading: false,
        shop_lists__error: null
      }

    }

    case FETCH_SLL_BEGIN:
      return {
        ...state,
        shop_lists_loading: true,
        shop_lists__error: null
      };

    case FETCH_SLL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        shop_lists_loading: false,
      };


    case SHOPPING_LIST_LIST_UPDATE_MEMBER:
      var shop_list_list = state.shop_lists.shop_list_list;
      var i = 0;
      console.log(action.payload);
      shop_list_list.forEach(element => {
        if (element.Shopping_List_Id === action.payload.member.Shopping_List_Id) {
          shop_list_list[i] = action.payload.member;
          //return shop_list_list; 
        }        
      });
      return {
        ...state,
        shop_lists: shop_list_list
      } 
      
    default:
      return state;      
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shop_list_list_reducer.js